export const PRODUCT_TYPE = {
    SERVICE_TYPE: 1,
    WAREHOUSE_TYPE: 2,
    COMPOSITE_TYPE: 3,
    ASSET_TYPE: 4,
}

export enum DiscountType {
   PERCENT = 'PERCENT',
   FIXED = 'FIXED',
}